import { Route } from '@angular/router';

import { UserResolver } from '@hmax-order/frontend/user';
import { CfgResolver } from './resolver/cfg.resolver';

export const cfgRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    resolve: { CfgResolver, UserResolver },
    loadComponent: () => import('./cfg.component').then((c) => c.CfgComponent),
  },
];
